export default "__VITE_ASSET__59_19GDR__"